<template>
  <el-dialog
    title="设置评审流程顺序"
    :visible.sync="dialogVisible"
    width="500px"
    class="dialog"
    :close-on-click-modal="false"
  >
    <el-table v-if="mainProgress.length > 0" border :data="mainProgress">
      <el-table-column
        label="序号"
        prop="index"
        align="center"
        type="index"
        width="60"
      />
      <el-table-column
        label="评审办法"
        align="center"
        min-width="200"
        show-overflow-tooltip
      >
        <template slot-scope="{ row }">
          <span>{{ row.title || ' - ' }}</span>
        </template>
      </el-table-column>
      <el-table-column label="排序" align="center" width="150">
        <template slot-scope="{ $index }">
          <el-button
            v-if="$index !== 0"
            type="text"
            @click="handleUp($index, mainProgress)"
          >
            上移
          </el-button>
          <el-button
            v-if="showDown($index, mainProgress)"
            type="text"
            @click="handleDown($index, mainProgress)"
          >
            下移
          </el-button>
        </template>
      </el-table-column>
    </el-table>
    <el-table
      v-if="otherProgress.length > 0"
      :data="otherProgress"
      class="m-t-16"
      border
      :span-method="objectSpanMethod"
    >
      <el-table-column
        label="序号"
        prop="index"
        align="center"
        type="index"
        width="60"
      />
      <el-table-column
        label="评审办法"
        align="center"
        min-width="200"
        show-overflow-tooltip
      >
        <template slot-scope="{ row }">
          <span>{{ row.title || ' - ' }}</span>
        </template>
      </el-table-column>
      <el-table-column label="排序" align="center" width="150">
        <template slot-scope="{ row, $index }">
          <template v-if="showAction(row)">
            <el-button
              v-if="showUp($index, otherProgress)"
              type="text"
              @click="handleUp($index, otherProgress)"
            >
              上移
            </el-button>
            <el-button
              v-if="showDown($index, otherProgress)"
              type="text"
              @click="handleDown($index, otherProgress)"
            >
              下移
            </el-button>
          </template>
        </template>
      </el-table-column>
    </el-table>
    <div class="operate flex col-center row-right m-t-16">
      <el-button @click="closeDialog">取消</el-button>
      <el-button type="primary" @click="confirm">确定</el-button>
    </div>
  </el-dialog>
</template>

<script>
import { cloneDeep } from 'lodash'
import {
  reviewMethodModelDict,
  reviewModelDict,
  reviewWayTypeDict
} from '@/dictionary/project/kpb-project'
import { moveInArray } from '@/utils/utils'

export default {
  name: 'BidReviewSortDialog',

  props: {
    visible: {
      type: Boolean,
      default: false
    },

    list: {
      type: Array,
      default: () => []
    },

    // 评审模式
    reviewModel: {
      type: [String, Number],
      default: reviewModelDict.DEFAULT.value
    },

    // 评审办法
    reviewMethod: {
      type: [String, Number],
      default: reviewMethodModelDict.DEFAULT.value
    }
  },

  data() {
    return {
      // 主要评审节点列表
      mainProgress: [],
      // 其它评审节点列表
      otherProgress: []
    }
  },

  computed: {
    dialogVisible: {
      get() {
        return this.visible
      },
      set(val) {
        this.$emit('update:visible', val)
      }
    },

    // 是否是双信封
    isDoubleFile() {
      return this.reviewModel === reviewModelDict.DOUBLE.value
    },

    // 是综合评分法
    isRankByScore() {
      return this.reviewMethod === reviewMethodModelDict.DEFAULT.value
    }
  },

  watch: {
    list: {
      handler(val) {
        if (val?.length) {
          this.mainProgress = []
          this.otherProgress = []
          const { QUALIFICATION, COMPLIANCE, RESPONSE } = reviewWayTypeDict(
            this.reviewModel
          )
          const mainArray = [QUALIFICATION, COMPLIANCE, RESPONSE].map(
            item => item.value
          )
          val.forEach(item => {
            if (mainArray.includes(item.wayType)) {
              this.mainProgress.push(cloneDeep(item))
            } else {
              this.otherProgress.push(cloneDeep(item))
            }
          })
        }
      },
      immediate: true,
      deep: true
    }
  },

  methods: {
    showAction(row) {
      // 双信封中，价格分不允许调整顺序
      const isQuotation =
        row.wayType === reviewWayTypeDict(this.reviewModel).QUOTATION.value ||
        row.wayType ===
          reviewWayTypeDict(this.reviewModel).QUOTATION_PASSING.value
      if (this.isDoubleFile && isQuotation) {
        return false
      }
      return true
    },

    showUp(index, list) {
      const row = list[index]
      const isQuotation =
        row.wayType === reviewWayTypeDict(this.reviewModel).QUOTATION.value ||
        row.wayType ===
          reviewWayTypeDict(this.reviewModel).QUOTATION_PASSING.value
      if (isQuotation && this.isDoubleFile) {
        return false
      }
      return index !== 0
    },

    /**
     * 上移评审办法
     */
    handleUp(index, list) {
      if (this.isDoubleFile && this.isRankByScore) {
        const row = list[index]
        if (
          row.wayType ===
          reviewWayTypeDict(this.reviewModel).TECHNICAL_PASSING.value
        ) {
          // 当前是技术评审，则上移时，需要移动技术评审和技术评分
          // 反过来，即是将商务评分下移两步
          moveInArray(list, index - 1, index + 1)
          return
        }
        if (
          row.wayType === reviewWayTypeDict(this.reviewModel).BUSINESS.value
        ) {
          // 当前时商务评分，则上移时，需要移动两步
          moveInArray(list, index, index - 2)
          return
        }
      }

      moveInArray(list, index, index - 1)
      list.forEach((item, index) => {
        item.orderNum = index + 1
      })
    },

    showDown(index, list) {
      if (list.length === 1) {
        return false
      }

      if (this.isDoubleFile && this.isRankByScore) {
        const row = list[index]
        const hasDoubleWay =
          row.wayType ===
          reviewWayTypeDict(this.reviewModel).TECHNICAL_PASSING.value
        const nextIndex = hasDoubleWay ? 2 : 1
        const nextRow = list[index + nextIndex] || {}
        const nextIsQuotation =
          nextRow.wayType ===
            reviewWayTypeDict(this.reviewModel).QUOTATION.value ||
          nextRow.wayType ===
            reviewWayTypeDict(this.reviewModel).QUOTATION_PASSING.value
        if (nextIsQuotation) {
          return false
        }
      }

      return index < list.length - 1
    },

    /**
     * 下移评审办法
     */
    handleDown(index, list) {
      if (this.isDoubleFile && this.isRankByScore) {
        const row = list[index]
        if (
          row.wayType ===
          reviewWayTypeDict(this.reviewModel).TECHNICAL_PASSING.value
        ) {
          // 当前是技术评审，则下移时，需要移动技术评审和技术评分
          // 反过来，即是将商务评分上移两部
          moveInArray(list, index + 2, index)
          return
        }
        if (
          row.wayType === reviewWayTypeDict(this.reviewModel).BUSINESS.value
        ) {
          // 当前时商务评分，则下移时，需要移动两步
          moveInArray(list, index, index + 2)
          return
        }
      }
      moveInArray(list, index, index + 1)
      list.forEach((item, index) => {
        item.orderNum = index + 1
      })
    },

    closeDialog() {
      this.dialogVisible = false
    },

    confirm() {
      const main = this.mainProgress.map((item, index) => {
        item.orderNum = index + 1
        return item
      })
      const other = this.otherProgress.map((item, index) => {
        item.orderNum = index + 1 + this.mainProgress.length
        return item
      })
      this.$emit('confirm', cloneDeep([...main, ...other]))
      this.closeDialog()
    },

    objectSpanMethod({ row, column, rowIndex, columnIndex }) {
      if (this.isDoubleFile && this.isRankByScore && columnIndex === 2) {
        const isTechnicalPassing =
          row.wayType ===
          reviewWayTypeDict(this.reviewModel).TECHNICAL_PASSING.value
        const isQuotationPassing =
          row.wayType ===
          reviewWayTypeDict(this.reviewModel).QUOTATION_PASSING.value
        if (isTechnicalPassing || isQuotationPassing) {
          return {
            rowspan: 2,
            colspan: 1
          }
        } else {
          return {
            rowspan: 1,
            colspan: 1
          }
        }
      }
    }
  }
}
</script>

<style scoped lang="scss"></style>
